var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('BaseSheet',{staticClass:"pa-6",attrs:{"elevation":_vm.elevation,"color":_vm.color}},[_vm._t("header"),_c('div',{class:{ 'mt-6': _vm.$slots.header, 'mb-6': _vm.$slots.footer }},[_vm._t("main"),_vm._t("default")],2),_vm._t("footer")],2)}
var staticRenderFns = []

export { render, staticRenderFns }